import { render, staticRenderFns } from "./HospitalOption.vue?vue&type=template&id=2f16171c&scoped=true"
import script from "./HospitalOption.vue?vue&type=script&lang=js"
export * from "./HospitalOption.vue?vue&type=script&lang=js"
import style0 from "./HospitalOption.vue?vue&type=style&index=0&id=2f16171c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f16171c",
  null
  
)

export default component.exports